export enum AddressType {
  Mailing = 'Mailing',
  Residential = 'Residential',
  Other = 'Other',
  Physical = 'Physical',
}
